export default "__VITE_ASSET__BI90H8Iy__"